import gql from "graphql-tag";

export default gql`
  query {
    pendingLocationRefillRequests {
      id
      detectedQuantity
      startWeight
      endWeight
      startedAt
      endedAt
      precision
      precisionPct
      inventoryLocation {
        id
        name
        code
        inventoryItem {
          id
          name
          unit
        }
      }
    }
    suppliers {
      id
      name
    }
    inventoryItems(materialType: CEMENT) {
      id
      name
      unit
    }
  }
`;
